import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { getErrorMessage } from "helpers";
import { merchantTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";
import { TerminalSolutionEditDto } from "types/api";

const useUpdateTerminalSolutionByMerchantMutation = (
	terminalId: string,
	merchantId: string,
	redirectTo?: string,
) => {
	const dispatch = useDispatch();
	const history = useHistory();
	return useMutation(
		(data: TerminalSolutionEditDto) => {
			return merchantTerminalService.updateTerminalSolution(
				terminalId,
				merchantId,
				data,
			);
		},
		{
			onSuccess(_result) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Terminal has been updated successfully",
					}),
				);
				redirectTo && history.push(redirectTo);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateTerminalSolutionByMerchantMutation;
